import React from 'react';
import { followGroupRequest } from 'entity/group/groupRedux';
import { useDispatch } from 'react-redux';
import { useIsSignedIn } from 'app/entity/user/userHooks';
import { openLoginModal } from 'app/dispatcher/modalDispatcher';
import { useSelectGroupById } from 'entity/group/groupHooks';
import clsx from 'clsx';

const JoinGroupPassportButton = (props: { groupId: number }) => {
  const { groupId } = props;
  const group = useSelectGroupById(groupId);
  const dispatch = useDispatch();
  const isSignedIn = useIsSignedIn();

  return (
    <span
      className={clsx(
        'text-xs hover:text-blue-500',
        group?.followedByCurrentUser && 'text-blue-500',
      )}
      onClick={() => {
        if (isSignedIn) {
          dispatch(followGroupRequest(groupId));
        } else {
          sessionStorage.setItem('new-group', JSON.stringify(groupId));
          dispatch(openLoginModal());
        }
      }}
    >
      {group?.followedByCurrentUser ? 'Joined' : 'Join'}
    </span>
  );
};

export default JoinGroupPassportButton;
